// extracted by mini-css-extract-plugin
export default {"numberValue":"IntegerInput_numberValue__nMnYT"};